import { render, staticRenderFns } from "./ZoomControls.vue?vue&type=template&id=b47dfb94&"
import script from "./ZoomControls.vue?vue&type=script&lang=js&"
export * from "./ZoomControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports